<template>
  <el-pagination
    v-bind="$attrs"
    v-model:current-page="currentPage"
    v-model:page-size="pageSize"
    :class="{ hidden: hidden }"
    class="pagination-container"
    :background="background"
    :layout="layout"
    :total="total"
    :page-sizes="[]"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
  />
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { scrollTo } from '@/utils/scroll-to'

export default defineComponent({
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true,
      default: 1
    },
    limit: {
      type: Number,
      default: 15
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    background: {
      type: Boolean,
      default: true
    },
    layout: {
      type: String,
      default: 'prev, pager, next'
    }
  },
  setup(props, context) {
    const currentPage = computed({
      get: () => props.page,
      set: (val) => {
        context.emit('update:page', val)
      }
    })

    const pageSize = computed({
      get: () => props.limit,
      set: (val) => {
        context.emit('update:limit', val)
      }
    })

    const handleSizeChange = (value: number) => {
      context.emit('pagination', { newPage: currentPage.value, limit: value })
      if (props.autoScroll) {
        scrollTo(0, 800)
      }
    }

    const handleCurrentChange = (value: number) => {
      context.emit('pagination', { newPage: value, limit: pageSize.value })
      if (props.autoScroll) {
        scrollTo(0, 800)
      }
    }

    const hidden = computed(() => {
      return props.total < 2
    })

    return {
      currentPage,
      pageSize,
      handleSizeChange,
      handleCurrentChange,
      hidden
    }
  }
})
</script>
<style lang="scss" scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  background: none;
}
.pagination-container.hidden {
  display: none;
}
</style>
